import BarChart from "../../BarChart/BarChart";
import SemiCirclePieChart from "../../SemiCirclePieChart/SemiCirclePieChart";
import BestWorstPerformer from "../../Reusable/BestWorstPerformer";
import {
  useState,
  useEffect,
  forwardRef,
  useRef,
  useImperativeHandle,
} from "react";
import AccordionBarChart from "../../AccordionBarChart/AccordionBarChart";
import Table from "./Table";
import apiClient from "../../../api";
import Log from "../Equity/Log";
import { observer } from "mobx-react";
import UserStore from "../../../store/UserStore";
import AnalyticsStore from "../../../store/AnalyticsStore";
import EmptyScreen from "../Equity/EmptyScreen/EmptyScreen";
import InternalTabsAnalytics from "../Equity/InternalTabsAnalytics/InternalTabsAnalytics";
// import Dropdown from "../Equity/Dopdown/Dropdown";
import { displayUnit, getLimitPer } from "../../../utils/functions";
import { getCookie } from "../../../utils/cookie";
import loaderGIF from "../../../assets/images/gifs/loaderGIF.gif";
import { tabData } from "../../../utils/constants";
import RadioDropdown from "../Equity/Dopdown/RadioDropdown";

const FixedIncome = observer(
  forwardRef(({ snippetDuration }, ref) => {
    const creditRef = useRef(null);
    const issureRef = useRef(null);
    const fixedDurationRef = useRef(null);

    // Exposing multiple refs via useImperativeHandle
    useImperativeHandle(ref, () => ({
      creditRef: creditRef.current,
      issureRef: issureRef.current,
      fixedDurationRef: fixedDurationRef.current,
    }));

    const [isBestLoading, setIsBestLoading] = useState(true);
    const [isWorstLoading, setIsWorstLoading] = useState(true);
    const [bestLength, setBestLength] = useState(0);
    const [worstLength, setWorstLength] = useState(0);
    const dropdownItems = [
      { id: 1, value: "Bonds + MF Debt", apiKey: "all" },
      { id: 2, value: "Mutual Funds", apiKey: "mutualfund" },
      { id: 3, value: "Debt", apiKey: "debt" },
    ];

    const familyId = UserStore?.userData?.family_id || getCookie("famid");
    const isPrimary =
      (AnalyticsStore?.overall?.isPrimary ||
        JSON.parse(getCookie("isPrimary"))) &&
      UserStore.getData === "fam"
        ? true
        : false;
    const userId =
      !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));

    const creditScoreSelectedOption =
      AnalyticsStore.fixedIncome.creditScoreSelectedOption;
    const issuerExposureSelectedOption =
      AnalyticsStore.fixedIncome.issuerExposureSelectedOption;

    const [creditScoreDropdownVisibility, setCreditScoreDropdownVisibility] =
      useState(false);
    const [
      issuerExposureDropdownVisibility,
      setIssuerExposureDropdownVisibility,
    ] = useState(false);

    const [order, setOrder] = useState("");
    const [sortField, setSortField] = useState("");
    const [currentSortKey, setCurrentSortKey] = useState("");

    const [activeTab, setActiveTab] = useState(
      snippetDuration || tabData[3].name
    );
    const [totalYtm, setTotalYtm] = useState();
    const [totalModDuration, setTotalModDuration] = useState();
    const [showRecordCount, setShowRecordCount] = useState(10);
    const [tableData, setTableData] = useState();
    const [bestAndWorstDropdownItems, setBestAndWorstDropdownItems] = useState(
      []
    );
    const selectedItemBestAndWorst =
      AnalyticsStore.fixedIncome.selectedItemBestAndWorst;
    const [selectedRadioBtn, setSelectedRadioBtn] = useState("irr");

    const [semiCircleDonutData, setSemiCircleDonutData] = useState([]);

    const creditRatingDropdownButtonRef = useRef(null);
    const creditRatingDropdownContainerRef = useRef(null);

    const issuerExporsureDropdownButtonRef = useRef(null);
    const issuerExporsureDropdownContainerRef = useRef(null);

    const handleSorting = (sortField, sortOrder) => {
      if (tableData && sortField !== "value") {
        const sorted = [...tableData].sort((a, b) => {
          return (
            a[sortField]
              .toString()
              .localeCompare(b[sortField].toString(), "en", {
                numeric: true,
              }) * (sortOrder === "asc" ? 1 : -1)
          );
        });
        setTableData(sorted);
      } else {
        const sorted = tableData.sort(function (a, b) {
          var textA = a.valueType.toUpperCase();
          var textB = b.valueType.toUpperCase();
          return (
            (textA < textB ? -1 : textA > textB ? 1 : 0) *
            (sortOrder === "asc" ? 1 : -1)
          );
        });
        setTableData(sorted);
      }
    };

    const handleSortingChange = (accessor, sortO) => {
      setCurrentSortKey(accessor);
      const sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      setSortField(accessor);
      setOrder(sortO ? sortO : sortOrder);
      handleSorting(accessor, sortO ? sortO : sortOrder);
    };

    const getCreditScore = () => {
      AnalyticsStore.setFixedIncome({
        ...AnalyticsStore.fixedIncome,
        creditScore: [],
        creditScoreLoading: true,
      });
      const uri = !userId
        ? `families/${familyId}/analytics/creditratingconcentration`
        : `clients/${userId}/analytics/creditratingconcentration`;
      apiClient
        .get(uri, {
          params: {
            instrumenttype:
              AnalyticsStore.fixedIncome.creditScoreSelectedOption?.apiKey,
          },
        })
        .then((res) => {
          const sortedGroups = res?.data?.instrumentGroupAllocations.map(
            (group) => {
              const instrumentAllocations = group.instrumentAllocations.map(
                (allocation) => ({
                  ...allocation,
                  assetAllocation: {
                    ...allocation.assetAllocation,
                    allocation_percentage: parseFloat(
                      allocation.assetAllocation.allocation_percentage
                    ),
                  },
                })
              );

              instrumentAllocations.sort(
                (a, b) =>
                  b.assetAllocation.allocation_percentage -
                  a.assetAllocation.allocation_percentage
              );

              return {
                ...group,
                instrumentAllocations,
              };
            }
          );

          AnalyticsStore.setFixedIncome({
            ...AnalyticsStore.fixedIncome,
            creditScore: {
              ...res.data,
              instrumentGroupAllocations: sortedGroups,
            },
            creditScoreLoading: false,
          });
          let arr = [];
          res?.data?.instrumentGroupAllocations?.map((i) =>
            arr.push({
              category: i.groupDescription,
              value: i.assetAllocation.allocation_percentage,
              full: 100,
              credit: `${i?.assetAllocation?.currentValue?.value} ${displayUnit(
                i?.assetAllocation?.currentValue?.value_type
              )}`,
            })
          );
          setSemiCircleDonutData([...arr]);
        })
        .catch((err) => {
          Log("Error : ", err);
        });
    };

    const getIssuerExposure = () => {
      AnalyticsStore.setFixedIncome({
        ...AnalyticsStore.fixedIncome,
        issuerExposure: [],
        issuerExposureLoading: true,
      });
      const uri = !userId
        ? `families/${familyId}/analytics/issuerexposure`
        : `clients/${userId}/analytics/issuerexposure`;
      apiClient
        .get(uri, {
          params: {
            instrumenttype:
              AnalyticsStore.fixedIncome.issuerExposureSelectedOption?.apiKey,
          },
        })
        .then((res) => {
          AnalyticsStore.setFixedIncome({
            ...AnalyticsStore.fixedIncome,
            issuerExposure: res?.data,
            issuerExposureLoading: false,
          });
          setShowRecordCount(10);
        })
        .catch((err) => {
          Log("Error : ", err);
        });
    };

    useEffect(() => {
      // best and worst performer
      const getPerformers = (bestPerformer = true) => {
        if (bestPerformer) {
          AnalyticsStore.setFixedIncome({
            ...AnalyticsStore.fixedIncome,
            bestPerformer: [],
            bestPerformerLoading: true,
          });
          setIsBestLoading(true);
          setBestLength(0);
        } else {
          AnalyticsStore.setFixedIncome({
            ...AnalyticsStore.fixedIncome,
            worstPerformerLoading: true,
            worstPerformer: [],
          });
          setIsWorstLoading(true);
          setWorstLength(0);
        }

        const uri = !userId
          ? `families/${familyId}/analytics/performers`
          : `clients/${userId}/analytics/performers`;
        apiClient
          .get(uri, {
            params: {
              type: bestPerformer ? "best" : "worst",
              duration: activeTab,
              asset_class_id: 4,
              instrumentvehicleid: selectedItemBestAndWorst?.id,
              return_type: "",
              is_xirr: selectedRadioBtn,
            },
          })
          .then((res) => {
            if (bestPerformer) {
              AnalyticsStore.setFixedIncome({
                ...AnalyticsStore.fixedIncome,
                bestPerformer: res.data,
                bestPerformerLoading: false,
              });
              setBestLength(res.data.length);
              setIsBestLoading(false);
            } else
              AnalyticsStore.setFixedIncome({
                ...AnalyticsStore.fixedIncome,
                worstPerformer: res.data,
                worstPerformerLoading: false,
              });
            setWorstLength(res.data.length);
            setIsWorstLoading(false);
          })
          .catch((err) => {
            Log("Error : ", err);
            AnalyticsStore.setFixedIncome({
              ...AnalyticsStore.fixedIncome,
              bestPerformerLoading: false,
              worstPerformerLoading: false,
            });
            setIsBestLoading(false);
            setIsWorstLoading(false);
            setBestLength(0);
            setWorstLength(0);
          });
      };
      getPerformers(true);
      getPerformers(false);
      // eslint-disable-next-line
    }, [selectedItemBestAndWorst, selectedRadioBtn, activeTab, userId]);

    useEffect(() => {
      setSelectedRadioBtn("irr");
      AnalyticsStore.setFixedIncome({
        ...AnalyticsStore.fixedIncome,
        creditScoreSelectedOption: dropdownItems[0],
        issuerExposureSelectedOption: dropdownItems[0],
      });
      const getDropdownItemsBestAndWorstPerformer = () => {
        const uri = !userId
          ? `families/${familyId}/portfolio/assetclasses/4/instrumentvehicles` // 4 is for fixed incode tab only
          : `clients/${userId}/portfolio/assetclasses/4/instrumentvehicles`;
        apiClient
          .get(uri, {
            params: {
              classType: "subassetclass",
              assetClassId: "4",
              isInfinity: UserStore?.isInfinity,
              MeasureInstrumentId: "",
              advisor: UserStore?.getDataWithNuvamaOrOther,
              isHolding: "0", //NTBD
            },
          })
          .then((res) => {
            setBestAndWorstDropdownItems([
              {
                id: "",
                name: "Across categories",
              },
              ...res.data,
            ]);
          })
          .catch((err) => {
            Log("Error : ", err);
          });
      };
      getDropdownItemsBestAndWorstPerformer();

      const getDurationAnalysis = () => {
        const isPrimary = UserStore.isPrimary;
        const familyId = UserStore.userData.family_id;
        const userId = UserStore.userData.user_id;
        const userType = UserStore.getData;
        let uri;
        if (userId && !isPrimary) {
          uri = `clients/${userId}/analytics/durationanalysis`;
        } else {
          if (userType === "fam") {
            uri = `families/${familyId}/analytics/durationanalysis`;
          } else {
            uri = `clients/${userId}/analytics/durationanalysis`;
          }
        }
        apiClient
          .get(uri)
          .then((res) => {
            AnalyticsStore.setFixedIncome({
              ...AnalyticsStore.fixedIncome,
              durationAnalysis: res.data,
            });
            setTableData(res.data);
            let totalObj = {};
            res.data.map((data) => {
              if (data.description === "Total") {
                totalObj = data;
              }
              return false;
            });
            setTotalYtm(totalObj.ytm);
            setTotalModDuration(totalObj.mod_duration);
          })
          .catch((err) => {
            Log("Error : ", err);
          });
      };

      // api call for duration analysis
      getDurationAnalysis();
      // eslint-disable-next-line
    }, [userId]);

    useEffect(() => {
      // api call for credit score
      getCreditScore();
      // eslint-disable-next-line
    }, [AnalyticsStore?.fixedIncome?.creditScoreSelectedOption?.id, userId]);

    useEffect(() => {
      // api call for issue exposure
      getIssuerExposure();
      // eslint-disable-next-line
    }, [AnalyticsStore?.fixedIncome?.issuerExposureSelectedOption, userId]);

    function showDropdownOfBestAndWorst() {
      return AnalyticsStore.fixedIncome.selectedItemBestAndWorst?.name ===
        "Across Categories"
        ? AnalyticsStore.fixedIncome.bestPerformer?.length > 0 ||
            AnalyticsStore.fixedIncome.worstPerformer?.length > 0 ||
            activeTab !== "ITD" ||
            isBestLoading ||
            isWorstLoading
        : true;
    }

    function hasDataToShow() {
      return (
        AnalyticsStore.fixedIncome.bestPerformer?.length > 0 ||
        AnalyticsStore.fixedIncome.worstPerformer?.length > 0 ||
        AnalyticsStore.fixedIncome.creditScore?.length > 0 ||
        AnalyticsStore.fixedIncome.durationAnalysis?.length > 0 ||
        AnalyticsStore.fixedIncome.issuerExposure?.length > 0 ||
        AnalyticsStore.fixedIncome.bestPerformerLoading ||
        AnalyticsStore.fixedIncome.worstPerformerLoading ||
        AnalyticsStore.fixedIncome.creditScoreLoading ||
        AnalyticsStore.fixedIncome.issuerExposureLoading ||
        showDropdownOfBestAndWorst()
      );
    }

    const colorsArray = [
      { border: "#0469DC", background: "#0469DC22" },
      { border: "#59C3C3", background: "#59C3C322" },
      { border: "#DB2255", background: "#DB225522" },
      { border: "#F45B69", background: "#F45B6922" },
      { border: "#FE7B2C", background: "#FE7B2C22" },
      { border: "#FE8E48", background: "#FE8E4822" },
      { border: "#F49867", background: "#F4986722" },
      { border: "#EEAD2D", background: "#EEAD2D22" },
      { border: "#F2c838", background: "#F2c83822" },
      { border: "#f5e342", background: "#f5e34222" },
    ];

    return (
      <>
        {hasDataToShow() ? (
          <div className="analytics__internal__tab">
            <div className="analytics__internal__tab analytics-card">
              {/* best and worst performer filter */}
              <BestWorstPerformer
                dropdownItems={bestAndWorstDropdownItems}
                selectedItem={selectedItemBestAndWorst}
                onChangeSelectedItem={(i) =>
                  AnalyticsStore.setFixedIncome({
                    ...AnalyticsStore.fixedIncome,
                    selectedItemBestAndWorst: i,
                  })
                }
                selectedRadioBtn={selectedRadioBtn}
                onChangeRadioBtn={(val) => setSelectedRadioBtn(val)}
                isData={showDropdownOfBestAndWorst()}
                loading={
                  AnalyticsStore.fixedIncome.bestPerformerLoading ||
                  AnalyticsStore.fixedIncome.worstPerformerLoading
                }
              />
              {/* duration tabs */}
              {(AnalyticsStore.fixedIncome.bestPerformer?.length > 0 ||
                AnalyticsStore.fixedIncome.worstPerformer.length > 0 ||
                activeTab !== "ITD" ||
                isBestLoading ||
                isWorstLoading) && (
                <InternalTabsAnalytics
                  tabsDataProp={tabData}
                  setSelectedTab={(data, index) => setActiveTab(data)}
                  selectedTab={activeTab}
                  isAnalytics={true}
                  ref={fixedDurationRef}
                />
              )}
              {/* best and worst performer internal bar chart */}
              {isBestLoading || isWorstLoading ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    margin: "148px 0px",
                  }}
                >
                  <img style={{ height: "40px" }} src={loaderGIF} alt="" />
                </div>
              ) : bestLength > 0 || worstLength > 0 ? (
                <div className="best-performer-container">
                  <span
                    className="width50Percent"
                    style={{ position: "relative", paddingRight: 37 }}
                  >
                    <span className="sub-title">Best Performers</span>
                    {AnalyticsStore.fixedIncome.bestPerformer.length !== 0 &&
                    !AnalyticsStore.fixedIncome.bestPerformerLoading ? (
                      <BarChart
                        containerClassName={"best-performer-bar-chart"}
                        data={AnalyticsStore.fixedIncome.bestPerformer}
                        is_xirr={selectedRadioBtn}
                      />
                    ) : (
                      <EmptyScreen
                        height={350}
                        loading={
                          AnalyticsStore.fixedIncome.bestPerformerLoading
                        }
                      />
                    )}
                  </span>
                  <span className="width50Percent" style={{ paddingLeft: 37 }}>
                    <span className="sub-title">Worst Performers</span>
                    {AnalyticsStore.fixedIncome.worstPerformer.length !== 0 ? (
                      <BarChart
                        containerClassName={"worst-performer-bar-chart"}
                        data={AnalyticsStore.fixedIncome.worstPerformer}
                        is_xirr={selectedRadioBtn}
                      />
                    ) : (
                      <EmptyScreen
                        height={350}
                        loading={
                          AnalyticsStore.fixedIncome.worstPerformerLoading
                        }
                      />
                    )}
                  </span>
                </div>
              ) : (
                <EmptyScreen
                  height={350}
                  loading={
                    AnalyticsStore.equity.worstPerformerLoading ||
                    AnalyticsStore.equity.bestPerformerLoading
                  }
                />
              )}

              {/* {(AnalyticsStore.fixedIncome.bestPerformer.length === 0 &&
              AnalyticsStore.fixedIncome.worstPerformer.length === 0) ||
            AnalyticsStore.fixedIncome.worstPerformerLoading ||
            AnalyticsStore.fixedIncome.bestPerformerLoading ? (
              <EmptyScreen
                height={275}
                loading={
                  AnalyticsStore.fixedIncome.worstPerformerLoading ||
                  AnalyticsStore.fixedIncome.bestPerformerLoading
                }
              />
            ) : (
              
            )} */}
            </div>
            {/* credit rating */}
            <div
              className="analytics-card"
              id={"CreditRatingExposure"}
              name="myTargetElement"
              ref={creditRef}
            >
              <div className="market-cap-allocation">
                <div className="equity-card-title">
                  <b>Credit Rating </b> Concentration
                </div>
                <span className="equity-dropdown-container">
                  <span className="credit-rating-show-me">Show me</span>
                  {/* <Dropdown
                    dropdownBtnStyles={{ width: 220 }}
                    selected={creditScoreSelectedOption}
                    open={creditScoreDropdownVisibility}
                    setOpen={setCreditScoreDropdownVisibility}
                    position={{ top: "56px", right: 0, left: 0 }}
                    items={dropdownItems}
                    handleChange={(selectedOption) => {
                      AnalyticsStore.setFixedIncome({
                        ...AnalyticsStore.fixedIncome,
                        creditScoreSelectedOption: selectedOption,
                      });
                    }}
                  /> */}
                  <RadioDropdown
                    dropdownBtnStyles={{ width: 220 }}
                    selected={creditScoreSelectedOption}
                    open={creditScoreDropdownVisibility}
                    setOpen={setCreditScoreDropdownVisibility}
                    position={{ top: "56px", right: 0, left: 0 }}
                    items={dropdownItems}
                    handleChange={(selectedOption) => {
                      AnalyticsStore.setFixedIncome({
                        ...AnalyticsStore.fixedIncome,
                        creditScoreSelectedOption: selectedOption,
                      });
                    }}
                    containerRef={creditRatingDropdownContainerRef}
                    ref={creditRatingDropdownButtonRef}
                  />
                </span>
              </div>
              {AnalyticsStore.fixedIncome.creditScore
                ?.instrumentGroupAllocations?.length > 0 &&
              !AnalyticsStore.fixedIncome.creditScoreLoading ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: 100,
                      marginLeft: -30,
                    }}
                  >
                    <div
                      className="semi-circle-donut-container"
                      style={{ width: "50%" }}
                    >
                      <SemiCirclePieChart
                        data={semiCircleDonutData}
                        className="semi-circle-donut credit-rating-semi-circle-donut"
                        styles={{}}
                      />
                      <div
                        className="pie-total-container"
                        style={{ marginLeft: 0 }}
                      >
                        <span className="pie-total">Total</span>
                        <span className="pie-credits">
                          {getLimitPer(
                            AnalyticsStore.fixedIncome.creditScore?.total?.value
                          )}
                          <span className="unitFont">
                            &nbsp;
                            {displayUnit(
                              AnalyticsStore.fixedIncome.creditScore?.total
                                ?.value_type
                            )}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="credit-rating-accordion-container">
                      <AccordionBarChart
                        data={
                          AnalyticsStore.fixedIncome.creditScore
                            ?.instrumentGroupAllocations
                        }
                        containerStyles={{ overflowX: "hidden" }}
                        colorsArray={
                          // colorsArray
                          [
                            { border: "#0469DC", background: "#0469DC22" },
                            { border: "#59C3C3", background: "#59C3C322" },
                            { border: "#F45B69", background: "#F45B6922" },
                            { border: "#F0B642", background: "#F0B64222" },
                            { border: "#FE7B2C", background: "#FE7B2C22" },
                            { border: "#f5e342", background: "#f5e34222" },
                            { border: "#4a4238", background: "#4a423822" },
                          ]
                        }
                      />
                    </div>
                  </div>
                </>
              ) : (
                <EmptyScreen
                  height={371}
                  loading={AnalyticsStore.fixedIncome.creditScoreLoading}
                />
              )}
            </div>
            {/* duration Analysis */}
            <div className="analytics-card">
              <div className="market-cap-allocation">
                <div className="equity-card-title">
                  Duration <b>Analysis</b>
                </div>
              </div>
              {tableData?.length > 0 ? (
                <>
                  <div className="total_fi_section">
                    <div>
                      <p
                        className="head_text"
                        style={{
                          color: "#7E8899",
                          fontFamily: "Encode Sans",
                        }}
                      >
                        Total YTM
                      </p>
                      <p
                        style={{
                          fontFamily: "Roboto",
                          color: "#060F1F",
                          fontSize: "18px",
                        }}
                      >
                        <b>{totalYtm}%</b>
                      </p>
                    </div>
                    <div>
                      <p
                        className="head_text"
                        style={{
                          color: "#7E8899",
                          fontFamily: "Encode Sans",
                        }}
                      >
                        Total Mod Duration
                      </p>
                      <p
                        style={{
                          fontFamily: "Roboto",
                          color: "#060F1F",
                          fontSize: "18px",
                        }}
                      >
                        <b>{totalModDuration}</b>
                      </p>
                    </div>
                  </div>

                  <Table
                    tableData={tableData}
                    handleSort={handleSortingChange}
                    currentSortKey={currentSortKey}
                    order={order}
                  />
                </>
              ) : (
                <EmptyScreen height={"220px"} />
              )}
            </div>
            {/* issue exposure */}
            <div
              className="analytics-card width50Percent market-cap-allocation-container"
              style={{ marginBottom: 100, height: "auto" }}
              id={"IssuerExposure"}
              ref={issureRef}
            >
              <div
                className="market-cap-allocation"
                style={{ marginBottom: 40 }}
              >
                <div className="equity-card-title">
                  Issuer <b>Exposure</b>
                </div>
                <span className="equity-dropdown-container">
                  <span className="equity-show-me">Show me</span>
                  {/* <Dropdown
                    dropdownBtnStyles={{ width: 185 }}
                    selected={issuerExposureSelectedOption}
                    open={issuerExposureDropdownVisibility}
                    setOpen={setIssuerExposureDropdownVisibility}
                    position={{ top: "56px", right: 0, left: 0, width: 185 }}
                    items={dropdownItems}
                    handleChange={(selectedOption) => {
                      AnalyticsStore.setFixedIncome({
                        ...AnalyticsStore.fixedIncome,
                        issuerExposureSelectedOption: selectedOption,
                      });
                    }}
                  /> */}
                  <RadioDropdown
                    dropdownBtnStyles={{ width: 185 }}
                    selected={issuerExposureSelectedOption}
                    open={issuerExposureDropdownVisibility}
                    setOpen={setIssuerExposureDropdownVisibility}
                    position={{ top: "56px", right: 0, left: 0, width: 185 }}
                    items={dropdownItems}
                    handleChange={(selectedOption) => {
                      AnalyticsStore.setFixedIncome({
                        ...AnalyticsStore.fixedIncome,
                        issuerExposureSelectedOption: selectedOption,
                      });
                    }}
                    containerRef={issuerExporsureDropdownContainerRef}
                    ref={issuerExporsureDropdownButtonRef}
                  />
                </span>
              </div>
              {AnalyticsStore.fixedIncome.issuerExposure?.length > 0 &&
              !AnalyticsStore.fixedIncome.issuerExposureLoading ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minHeight: 625,
                    paddingRight: 10,
                  }}
                >
                  <AccordionBarChart
                    percentTextColor={"#060F1F"}
                    data={AnalyticsStore.fixedIncome.issuerExposure?.slice(
                      0,
                      showRecordCount
                    )}
                    colorsArray={colorsArray}
                  />
                  {AnalyticsStore.fixedIncome.issuerExposure?.length >
                    showRecordCount && (
                    <button
                      className="show-more-container"
                      onClick={() => setShowRecordCount(showRecordCount + 10)}
                      style={{
                        borderWidth: 0,
                        backgroundColor: "transparent",
                        alignSelf: "center",
                        marginTop: "auto",
                      }}
                    >
                      Show more
                      <svg
                        style={{ marginLeft: 10 }}
                        width="26"
                        height="14"
                        viewBox="0 0 26 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.59448 0.624337C2.19414 0.331437 2.91765 0.580113 3.21049 1.17981C3.67945 2.14007 4.25077 3.01986 4.90614 3.80201C4.93973 3.83717 4.97078 3.87391 4.99931 3.91185C5.95556 5.02617 7.08475 5.93593 8.33202 6.58964C8.36497 6.60269 8.39762 6.61731 8.4299 6.6335C8.46732 6.65235 8.50334 6.67277 8.53793 6.69476C9.91212 7.37699 11.4231 7.75133 13 7.75133C14.5766 7.75133 16.0877 7.37699 17.4619 6.69476C17.4966 6.67277 17.5326 6.65235 17.57 6.6335C17.6024 6.61731 17.6352 6.60269 17.6682 6.58964C18.9141 5.93653 20.0422 5.02811 20.9978 3.91548C21.028 3.875 21.0612 3.83584 21.0972 3.79851C21.7514 3.01732 22.3217 2.13886 22.79 1.18017C23.0831 0.580596 23.8066 0.331921 24.4062 0.624821C25.0058 0.917842 25.2544 1.64139 24.9614 2.24097C24.5647 3.05309 24.1019 3.82255 23.5805 4.5397L25.3335 6.29275C25.8054 6.76472 25.8054 7.52972 25.3335 8.00158C24.8616 8.47355 24.0966 8.47355 23.6246 8.00158L22 6.37697C21.2981 7.06765 20.5305 7.68028 19.7079 8.20095L20.7258 10.2305C21.025 10.827 20.7841 11.5531 20.1875 11.8523C19.591 12.1515 18.8649 11.9104 18.5657 11.314L17.5549 9.2986C16.4964 9.71753 15.3752 9.9952 14.2083 10.1093V12.5847C14.2083 13.252 13.6674 13.793 13 13.793C12.3326 13.793 11.7917 13.252 11.7917 12.5847V10.1093C10.6248 9.9952 9.50351 9.71753 8.44503 9.2986L7.43426 11.314C7.13509 11.9104 6.40898 12.1515 5.81245 11.8523C5.21593 11.5531 4.97489 10.827 5.27406 10.2305L6.29199 8.20095C5.46949 7.68016 4.70192 7.06753 4.00001 6.37685L2.37526 8.00158C1.90337 8.47355 1.1383 8.47355 0.666409 8.00158C0.19453 7.52972 0.19453 6.76472 0.666409 6.29275L2.41975 4.53946C1.89838 3.82219 1.43561 3.0526 1.03895 2.24024C0.746099 1.64067 0.994822 0.917116 1.59448 0.624337Z"
                          fill="#03002F"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              ) : (
                <EmptyScreen
                  height={629}
                  loading={AnalyticsStore.fixedIncome.issuerExposureLoading}
                />
              )}
            </div>
          </div>
        ) : (
          <div className="analytics-card" style={{ marginTop: 0 }}>
            <EmptyScreen height={400} />
          </div>
        )}
      </>
    );
  })
);

export default FixedIncome;
